import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { Companion_instance1a0yry1hi33tg as Companion_instance } from './AbstractList.mjs';
import { AbstractMutableList192xfq8ycgofs as AbstractMutableList } from './AbstractMutableListJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../js/coreRuntime.mjs';
import {
  copyToArray2j022khrow2yi as copyToArray,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
} from './collectionJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../hacks.mjs';
import { get_lastIndex1yw0x4k50k51w as get_lastIndex } from './CollectionsKt.mjs';
import { indexOf3ic8eacwbbrog as indexOf } from './_Arrays.mjs';
import { arrayToString1r7op7afgkivw as arrayToString } from './collectionsHacks.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from './Collections.mjs';
import { RandomAccess1jbw8sdogqb8x as RandomAccess } from './RandomAccess.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = ArrayList().m2(0);
        this_0.l2_1 = true;
        tmp.j8_1 = this_0;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 === VOID)
    new (Companion())();
  return Companion_instance_0;
}
function increaseLength($this, amount) {
  var previous = $this.v2();
  // Inline function 'kotlin.js.asDynamic' call
  $this.k2_1.length = $this.v2() + amount | 0;
  return previous;
}
function rangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  Companion_instance.n7(index, $this.v2());
  return index;
}
function insertionRangeCheck($this, index) {
  // Inline function 'kotlin.apply' call
  Companion_instance.e7(index, $this.v2());
  return index;
}
var ArrayListClass;
function ArrayList() {
  if (ArrayListClass === VOID) {
    class $ extends AbstractMutableList() {
      static l6(array) {
        Companion_getInstance();
        var $this = this.m7();
        $this.k2_1 = array;
        $this.l2_1 = false;
        return $this;
      }
      static u2() {
        Companion_getInstance();
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        return this.l6(tmp$ret$0);
      }
      static m2(initialCapacity) {
        Companion_getInstance();
        // Inline function 'kotlin.emptyArray' call
        var tmp$ret$0 = [];
        var $this = this.l6(tmp$ret$0);
        // Inline function 'kotlin.require' call
        if (!(initialCapacity >= 0)) {
          var message = 'Negative initial capacity: ' + initialCapacity;
          throw IllegalArgumentException().s2(toString(message));
        }
        return $this;
      }
      static o2(elements) {
        Companion_getInstance();
        // Inline function 'kotlin.collections.toTypedArray' call
        var tmp$ret$0 = copyToArray(elements);
        return this.l6(tmp$ret$0);
      }
      k8() {
        this.t6();
        this.l2_1 = true;
        return this.v2() > 0 ? this : Companion_getInstance().j8_1;
      }
      l8() {
      }
      m8(minCapacity) {
      }
      v2() {
        return this.k2_1.length;
      }
      w2(index) {
        var tmp = this.k2_1[rangeCheck(this, index)];
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
      o3(index, element) {
        this.t6();
        rangeCheck(this, index);
        // Inline function 'kotlin.apply' call
        var this_0 = this.k2_1[index];
        this.k2_1[index] = element;
        var tmp = this_0;
        return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      }
      n2(element) {
        this.t6();
        // Inline function 'kotlin.js.asDynamic' call
        this.k2_1.push(element);
        this.z6_1 = this.z6_1 + 1 | 0;
        return true;
      }
      g5(index, element) {
        this.t6();
        // Inline function 'kotlin.js.asDynamic' call
        this.k2_1.splice(insertionRangeCheck(this, index), 0, element);
        this.z6_1 = this.z6_1 + 1 | 0;
      }
      z2(elements) {
        this.t6();
        if (elements.s1())
          return false;
        var offset = increaseLength(this, elements.v2());
        // Inline function 'kotlin.collections.forEachIndexed' call
        var index = 0;
        var _iterator__ex2g4s = elements.u1();
        while (_iterator__ex2g4s.v1()) {
          var item = _iterator__ex2g4s.w1();
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          var index_0 = checkIndexOverflow(_unary__edvuaz);
          this.k2_1[offset + index_0 | 0] = item;
        }
        this.z6_1 = this.z6_1 + 1 | 0;
        return true;
      }
      h5(index) {
        this.t6();
        rangeCheck(this, index);
        this.z6_1 = this.z6_1 + 1 | 0;
        var tmp;
        if (index === get_lastIndex(this)) {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = this.k2_1.pop();
        } else {
          // Inline function 'kotlin.js.asDynamic' call
          tmp = this.k2_1.splice(index, 1)[0];
        }
        return tmp;
      }
      o7(fromIndex, toIndex) {
        this.t6();
        this.z6_1 = this.z6_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        this.k2_1.splice(fromIndex, toIndex - fromIndex | 0);
      }
      f5() {
        this.t6();
        var tmp = this;
        // Inline function 'kotlin.emptyArray' call
        tmp.k2_1 = [];
        this.z6_1 = this.z6_1 + 1 | 0;
      }
      w4(element) {
        return indexOf(this.k2_1, element);
      }
      toString() {
        return arrayToString(this.k2_1);
      }
      n8() {
        return [].slice.call(this.k2_1);
      }
      toArray() {
        return this.n8();
      }
      t6() {
        if (this.l2_1)
          throw UnsupportedOperationException().o8();
      }
    }
    initMetadataForClass($, 'ArrayList', $.u2, VOID, [AbstractMutableList(), KtMutableList(), RandomAccess()]);
    ArrayListClass = $;
  }
  return ArrayListClass;
}
//region block: exports
export {
  ArrayList as ArrayList3it5z8td81qkl,
};
//endregion

//# sourceMappingURL=ArrayListJs.mjs.map
